import React from 'react';
import { connect } from 'react-redux';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { IWeekDetailsState, IWeeksReviewBookState } from '@store/slices';
import { RootState } from '@share/utils';
import { BookingErrorsEnum } from '@share/common-types';
import { ModalAvailabilityStatus, Type } from '@components';

import './style.scss';

interface IMapStateToProps {
  weeksDetailsStore: IWeekDetailsState;
  weeksReviewBookStore: IWeeksReviewBookState;
}

interface IProps extends WrappedComponentProps, IMapStateToProps, RouteComponentProps {}

function WeeksAvailabilityStatusModalComponent(props: IProps) {
  const { weeksDetailsStore, weeksReviewBookStore } = props;
  const { weeksBookingSummary, bookingErrorCode } = weeksReviewBookStore;
  const { error } = weeksDetailsStore;

  const hasSoldout = BookingErrorsEnum.SoldOut === error || BookingErrorsEnum.SoldOut === bookingErrorCode;
  const isUnavailable = BookingErrorsEnum.RoomsUnavailable === error || BookingErrorsEnum.RoomsUnavailable === bookingErrorCode;;

  return (
    <ModalAvailabilityStatus
      hasSoldout={hasSoldout}
      isUnavailable={isUnavailable}
      type={Type.WEEKS}
      propertyId={weeksBookingSummary?.bookingCard?.condoId}
      bookingErrorCode={bookingErrorCode}
    />
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    weeksDetailsStore: state.weeksDetailsStore,
    weeksReviewBookStore: state.weeksReviewBookStore,
  };
};

export const WeeksAvailabilityStatusModal = connect(mapStateToProps)(injectIntl(withRouter(WeeksAvailabilityStatusModalComponent)));
